import { render } from "./oap-quiz.vue?vue&type=template&id=905ea3b2"
import script from "./oap-quiz.vue?vue&type=script&lang=js"
export * from "./oap-quiz.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__